export const USER_FLOW_ID = 'rentablo-cashback-lp';
